<template>
  <section class="about-section section" id="about">
    <div class="container">
      <div class="about-grid reveal">
        <div class="about-text">
          <div class="section-header" style="text-align:left;margin-bottom:24px">
            <span class="label">{{ $store.getters.t('about.subtitle') }}</span>
            <h2>{{ $store.getters.t('about.title') }}</h2>
          </div>
          <h3 class="about-title">{{ $store.getters.t('about.titleText') }}</h3>
          <p class="about-desc">{{ $store.getters.t('about.desc1') }}</p>
          <p class="about-desc">{{ $store.getters.t('about.desc2') }}</p>
          <div class="about-highlights">
            <div class="highlight-item" v-for="(h, i) in highlights" :key="i">
              <span class="highlight-val">{{ h.val }}</span>
              <span class="highlight-label">{{ h.label }}</span>
            </div>
          </div>
        </div>
        <div class="about-visual">
          <div class="about-graphic">
            <div class="glow-orb"></div>
            <div class="glow-orb orb-2"></div>
            <div class="arch-diagram">
              <div class="arch-layer layer-1">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
                <span>{{ $store.getters.isZh ? 'AI 应用层' : 'AI Application Layer' }}</span>
              </div>
              <div class="arch-arrow">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 5v14M5 12l7 7 7-7"/></svg>
              </div>
              <div class="arch-layer layer-2">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8"/></svg>
                <span>{{ $store.getters.isZh ? '数据中台' : 'Data Middle Platform' }}</span>
              </div>
              <div class="arch-arrow">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 5v14M5 12l7 7 7-7"/></svg>
              </div>
              <div class="arch-layer layer-3">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><path d="M2 12h20"/></svg>
                <span>{{ $store.getters.isZh ? 'IoT / 设备层' : 'IoT / Device Layer' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AboutSection',
  computed: {
    highlights() {
      const t = (k) => this.$store.getters.t(k)
      return [
        { val: t('about.highlight1Val'), label: t('about.highlight1') },
        { val: t('about.highlight2Val'), label: t('about.highlight2') },
        { val: t('about.highlight3Val'), label: t('about.highlight3') },
        { val: t('about.highlight4Val'), label: t('about.highlight4') }
      ]
    }
  }
}
</script>

<style scoped>
.about-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 64px;
  align-items: center;
}
.about-title {
  font-size: 20px;
  font-weight: 700;
  color: #f1f5f9;
  margin-bottom: 16px;
}
.about-desc {
  color: #94a3b8;
  font-size: 14.5px;
  line-height: 1.85;
  margin-bottom: 14px;
}
.about-highlights {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin-top: 24px;
}
.highlight-item {
  background: rgba(30,41,59,.6);
  border: 1px solid rgba(255,255,255,.04);
  border-radius: 12px;
  padding: 18px 12px;
  text-align: center;
  transition: all .3s;
}
.highlight-item:hover { border-color: rgba(59,130,246,.15); background: rgba(30,41,59,.8); }
.highlight-val {
  display: block;
  font-size: 22px;
  font-weight: 800;
  background: linear-gradient(135deg, #93c5fd, #3b82f6);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
.highlight-label {
  font-size: 11px;
  color: #64748b;
  margin-top: 4px;
  display: block;
  font-weight: 500;
}

/* Visual Side */
.about-visual { position: relative; display: flex; align-items: center; justify-content: center; }
.about-graphic {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 380px;
}
.glow-orb {
  position: absolute;
  width: 240px; height: 240px;
  background: radial-gradient(circle, rgba(59,130,246,.12), transparent 65%);
  border-radius: 50%;
  animation: orbFloat1 8s ease-in-out infinite;
}
.orb-2 {
  width: 180px; height: 180px;
  background: radial-gradient(circle, rgba(139,92,246,.1), transparent 65%);
  animation: orbFloat2 10s ease-in-out infinite;
}
@keyframes orbFloat1 {
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(15px, -20px); }
}
@keyframes orbFloat2 {
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(-15px, 15px); }
}
.arch-diagram {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 280px;
}
.arch-layer {
  width: 100%;
  padding: 16px 20px;
  border-radius: 12px;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  color: #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition: transform .3s;
}
.arch-layer:hover { transform: scale(1.03); }
.layer-1 { background: linear-gradient(135deg, rgba(59,130,246,.22), rgba(59,130,246,.06)); border: 1px solid rgba(59,130,246,.2); }
.layer-2 { background: linear-gradient(135deg, rgba(139,92,246,.22), rgba(139,92,246,.06)); border: 1px solid rgba(139,92,246,.2); }
.layer-3 { background: linear-gradient(135deg, rgba(16,185,129,.22), rgba(16,185,129,.06)); border: 1px solid rgba(16,185,129,.2); }
.arch-arrow {
  color: #475569;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (max-width: 768px) {
  .about-grid { grid-template-columns: 1fr; gap: 40px; }
  .about-highlights { grid-template-columns: repeat(2, 1fr); }
  .about-graphic { min-height: 300px; }
  .arch-diagram { width: 240px; }
}
</style>
